var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTweeter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 73,
    viewBox: "0 0 76 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 72.5807,
    rx: 36.2903,
    transform: "matrix(-1 0 0 1 75.6666 0)",
    fill: "#6E6E6E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.0292 55.4335C28.3979 55.4335 19.3041 42.0968 19.3041 30.5383C19.3041 30.1573 19.3041 29.7762 19.3229 29.4133C17.5604 28.1795 16.0229 26.6371 14.8041 24.8771C16.4166 25.5666 18.1604 26.0383 19.9979 26.2561C18.1229 25.1674 16.6979 23.4617 16.0229 21.4113C17.7666 22.4093 19.6979 23.1351 21.7604 23.5343C23.4104 21.8287 25.7541 20.7762 28.3604 20.7762C33.3479 20.7762 37.3979 24.6956 37.3979 29.5222C37.3979 30.2117 37.3229 30.8831 37.1542 31.5182C44.6729 31.1553 51.3291 27.6714 55.7916 22.373C56.5604 23.6613 57.0104 25.1674 57.0104 26.7641C57.0104 29.7944 55.4166 32.4799 52.9791 34.0404C54.4604 34.0041 55.8479 33.6049 57.0667 32.9517C57.0667 32.9879 57.0667 33.0242 57.0667 33.0605C57.0667 37.3065 53.9542 40.8267 49.8104 41.6432C50.5604 41.8428 51.3667 41.9517 52.1917 41.9517C52.7729 41.9517 53.3354 41.8972 53.8979 41.7883C52.7542 45.2722 49.4166 47.7944 45.4604 47.867C48.5541 50.2077 52.4542 51.6049 56.6917 51.6049C57.4229 51.6049 58.1354 51.5686 58.8479 51.4779C54.8917 53.9819 50.1292 55.4335 45.0292 55.4335Z",
    fill: "#ECEEED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTweeter);
export default __webpack_public_path__ + "static/media/tweeter.16c25f697fe7271b4d6f643b121cf784.svg";
export { ForwardRef as ReactComponent };